import {
  LocalStorageKey,
  localStorageUtil,
  useThemeStore,
  getDianaSystemColor,
  ExtendedThemeNames,
} from '@diana/core';
import { parse } from 'tldts';
import { matchPath } from 'react-router-dom';
import { routeUrls } from './Routing/RouteUrls';

function getDomain(hostname: string): string | null {
  const { domainWithoutSuffix } = parse(`http://${hostname}`);
  return domainWithoutSuffix || null;
}

export function getDefaultEnvironment() {
  const customDomain = getDomain(window.location.hostname);
  if (customDomain && ['adpclear', 'marinestream'].includes(customDomain)) {
    return customDomain;
  }

  return null;
}

export function handleAnonId() {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('anonId')) {
    const anonId = urlParams.get('anonId');
    localStorageUtil.setItem({ key: LocalStorageKey.anonId, value: anonId ?? '' });
    urlParams.delete('anonId');
    const newUrl = window.location.pathname + '?' + urlParams.toString();
    window.history.replaceState(null, document.title, newUrl);
  }
}

export function addSystemThemeListener() {
  if (window.matchMedia) {
    const colorSchemeQuery = window.matchMedia('(prefers-color-scheme: dark)');
    colorSchemeQuery.addEventListener('change', () => {
      const themeFromStorage = localStorageUtil.getItem({
        key: LocalStorageKey.defaultTheme,
      }) as ExtendedThemeNames;

      if (themeFromStorage === 'system') {
        const theme = getDianaSystemColor();
        useThemeStore.getState().setTheme(theme);
      }
    });
  }
}

export function handleBillingParams() {
  const urlParams = new URLSearchParams(window.location.search);

  const sessionId = urlParams.get('session_id');
  if (sessionId) {
    localStorageUtil.setItem({ key: LocalStorageKey.billingSessionId, value: sessionId });
  }

  const priceId = urlParams.get('price_id');
  if (priceId) {
    localStorageUtil.setItem({ key: LocalStorageKey.billingPriceId, value: priceId });
  }
}

export function isLegacyUrl() {
  return (
    (window.location.pathname.startsWith('/app') ||
      window.location.pathname.startsWith('/select')) &&
    !window.location.pathname.includes('oidc') &&
    !matchPath(routeUrls.legacyOpenFile.path, window.location.pathname) &&
    !matchPath(routeUrls.legacyWork.path, window.location.pathname) &&
    !matchPath(routeUrls.legacyWorkPrint, window.location.pathname)
  );
}
